import React, { FC } from 'react'

import { StyledTime } from '../../EventStatisticTime.styled'

import { IEventStatisticTimeCurrentProps } from './EventStatisticTimeCurrent.types'

export const EventStatisticTimeCurrent: FC<IEventStatisticTimeCurrentProps> = ({
  value
}) => <StyledTime>{value}</StyledTime>
